import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import '@locales';

import './index.css';
import App from './App.tsx';

Sentry.init({
  dsn: "https://b047841bd5c5e545d5c37b118e81e73f@o501158.ingest.us.sentry.io/4508931671064576"
});

createRoot(document.getElementById('root')!).render(<App />);
